<template>
    <v-container fluid class="ma-0 pa-0">
        <v-layout fill-height>
            <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 1920 495" preserveAspectRatio="none">
                <defs>
                    <linearGradient id="b" x1=".341" y1="-.067" x2=".868" y2="2.24" gradientUnits="objectBoundingBox">
                        <stop offset="0" :stop-color="colors.stopColor1" />
                        <stop offset="1" :stop-color="colors.stopColor2" />
                        <stop offset="1" :stop-color="colors.stopColor3" />
                    </linearGradient>
                    <clipPath id="a">
                        <path transform="translate(0 585)" :fill="colors.rectColor" d="M0 0h1920v495H0z" />
                    </clipPath>
                </defs>
                <g transform="translate(0 -585)" clip-path="url(#a)">
                    <path transform="translate(0 585)" fill="url(#b)" d="M0 0h1920v495H0z" />
                    <circle cx="577.5" cy="577.5" r="577.5" transform="translate(-433 473)" :fill="colors.circleColor1" />
                    <circle cx="641.5" cy="641.5" r="641.5" transform="translate(256 758)" :fill="colors.circleColor2" />
                </g>
            </svg>
            <slot></slot>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: 'loginSVG',
        props: {
            colors: {
                type: Object,
                required: true
            }
        //    rectColor: {
        //        type: String,
        //        required: true
        //    },
        //    stopColor1: {
        //        type: String,
        //        required: true
        //    },
        //    stopColor2: {
        //        type: String,
        //        required: true
        //    },
        //    stopColor3: {
        //        type: String,
        //        required: true
        //    },
        //    circleColor1: {
        //        type: String,
        //        required: true
        //    },
        //    circleColor2: {
        //        type: String,
        //        required: true
        //    },
        },
    }
</script>

<style scoped>
    .my-svg-component {
        /* Scoped CSS here */
    }
</style>